<script>
import { AuthService } from "@kinetics254/cassandra-base/modules/auth";

export default {
  name: "GrievanceCaseForm",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    record: null,
  },
  data() {
    return {
      form: {
        systemId: "",
        caseType: "",
        description: "",
        employeeNo: "",
      },
      valid: true,
      loading: false,
      required: [(v) => !!v || "Field is required"],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    caseTypes() {
      return this.$store.getters["Grievances/grievanceGetters"]("caseTypes");
    },
    user() {
      return AuthService.user;
    },
  },
  watch: {
    record: function (newVal) {
      if (newVal) {
        this.form.systemId = newVal.systemId;
        this.form.caseType = newVal.caseType;
        this.form.description = newVal.description;
      }
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const operation = this.form.systemId ? "updateCase" : "addCase";
        this.form.employeeNo = this.user.employee;
        this.$store
          .dispatch(`Grievances/${operation}`, this.form)
          .then(() => {
            this.$refs.form.reset();
            this.close();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>

<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="text-h5">Grievance Case Form</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-select
            outlined
            :items="caseTypes"
            label="Case Type *"
            v-model="form.caseType"
            :rules="required"
          ></v-select>

          <v-textarea
            outlined
            label="Description *"
            v-model="form.description"
            rows="3"
            :rules="required"
          ></v-textarea>

          <v-btn @click="close" :disabled="loading" class="mr-2">Cancel</v-btn>
          <v-btn
            color="primary"
            @click="submit"
            :disabled="loading"
            :loading="loading"
            >Save</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
